"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Odnoklassniki = function Odnoklassniki(props) {
	return _react2.default.createElement(
		"svg",
		_extends({}, props, { viewBox: "0 0 48 48" }),
		_react2.default.createElement("path", { d: "M24.01 24.1a9.686 9.686 0 0 0 9.806-9.54 9.81 9.81 0 0 0-19.614 0 9.687 9.687 0 0 0 9.807 9.54zm0-13.493a3.952 3.952 0 1 1-4.062 3.952 4.01 4.01 0 0 1 4.06-3.96zm3.967 21.278a18.652 18.652 0 0 0 5.695-2.3 2.753 2.753 0 0 0 .9-3.856 2.918 2.918 0 0 0-3.962-.88 12.743 12.743 0 0 1-13.2 0 2.916 2.916 0 0 0-3.96.88 2.752 2.752 0 0 0 .9 3.855 18.68 18.68 0 0 0 5.694 2.3L14.56 37.22a2.744 2.744 0 0 0 0 3.955 2.93 2.93 0 0 0 4.065 0l5.386-5.243 5.39 5.238a2.928 2.928 0 0 0 4.062 0 2.74 2.74 0 0 0 0-3.954z" })
	);
};

exports.default = Odnoklassniki;


//////////////////
// WEBPACK FOOTER
// ./~/react-share-icons/lib/Odnoklassniki/index.js
// module id = 174
// module chunks = 0